var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFE6C0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3629_17020",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3629_17020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 18.75C15.2125 18.75 15.3906 18.6781 15.5344 18.5344C15.6781 18.3906 15.75 18.2125 15.75 18C15.75 17.7875 15.6781 17.6094 15.5344 17.4656C15.3906 17.3219 15.2125 17.25 15 17.25C14.7875 17.25 14.6094 17.3219 14.4656 17.4656C14.3219 17.6094 14.25 17.7875 14.25 18C14.25 18.2125 14.3219 18.3906 14.4656 18.5344C14.6094 18.6781 14.7875 18.75 15 18.75ZM14.25 15.75H15.75V11.25H14.25V15.75ZM15 22.5C13.9625 22.5 12.9875 22.3031 12.075 21.9094C11.1625 21.5156 10.3688 20.9813 9.69375 20.3063C9.01875 19.6313 8.48438 18.8375 8.09063 17.925C7.69687 17.0125 7.5 16.0375 7.5 15C7.5 13.9625 7.69687 12.9875 8.09063 12.075C8.48438 11.1625 9.01875 10.3688 9.69375 9.69375C10.3688 9.01875 11.1625 8.48438 12.075 8.09063C12.9875 7.69687 13.9625 7.5 15 7.5C16.0375 7.5 17.0125 7.69687 17.925 8.09063C18.8375 8.48438 19.6313 9.01875 20.3063 9.69375C20.9813 10.3688 21.5156 11.1625 21.9094 12.075C22.3031 12.9875 22.5 13.9625 22.5 15C22.5 16.0375 22.3031 17.0125 21.9094 17.925C21.5156 18.8375 20.9813 19.6313 20.3063 20.3063C19.6313 20.9813 18.8375 21.5156 17.925 21.9094C17.0125 22.3031 16.0375 22.5 15 22.5Z",
    fill: "#ED8F03"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank2);
export default __webpack_public_path__ + "static/media/Rank-2.da2147fff145962e1702cd904226a3e5.svg";
export { ForwardRef as ReactComponent };